export const createURL = (route: string, queryParams?: Record<string, string>): string => {
  let url = window.location.origin;
  url += route;
  if (queryParams) {
    url += '?';
    const params = new URLSearchParams(queryParams);
    url += params.toString();
  }
  return url;
};

export const addNewParams = (url: string, queryParams?: Record<string, string>): string => {
  let newUrl = url;
  if (queryParams) {
    newUrl += url.includes('?') ? '&' : '?';
    const params = new URLSearchParams(queryParams);
    newUrl += params.toString().concat('&');
  }
  return newUrl;
};
